/**
 * index.js
 * --------
 * Application entry point.
 * Imports global styles (CSS custom properties, resets, animation utilities)
 * then mounts the React app into the #root DOM node.
 * BrowserRouter is provided here so the entire component tree has access
 * to React Router context.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/globals.css';
import App from './App';

// Apply saved theme immediately to prevent flash of wrong theme
const savedTheme = localStorage.getItem('labora-theme') || 'dark';
document.documentElement.setAttribute('data-theme', savedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
